export default __webpack_public_path__ + "static/media/amex.d5892fd5.svg";